<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesPrdPpdScheduledResultItemPsriResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      :header-btn-add-disable="loading"
                                      listen-add-new-entity-event
                                      @addNewEntity="$refs.ppdSelect.showModal()"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"></em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <ReBModal ref="ppdSelect" header="项目计划详情选择">
            <SimpleListGroup with-search :data-list="detailTreeList" @rowClick="prpSelected"></SimpleListGroup>
        </ReBModal>
    </div>
</template>
<script>
// Author Liang Gang Qiang
// Date 2022-01-04 17:58:22

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import SimpleListGroup from "@/components/echarts-part/CalendarShift/cells/stuffs/SimpleListGroup";

export default {
    name: "sithMesPrdPpdScheduledResultItemPsriListView",
    components: {SimpleListGroup, ReBModal},
    mixins: [emCommonListMixin, emCustomVuexMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        prpId() {
            return this.$store.state.routeStore.object.prpId;
        }
    },
    data() {
        return {
            detailTreeList: [],
            loading: false,
        }
    },
    mounted() {
        this.getPpdByPrpId();
    },
    methods: {
        getPpdByPrpId() {
            console.log(this.$store.state.routeStore.object);
            if (this.prpId) {
                this.loading = true;
                this.$store.dispatch('api/get', {
                    url: `${process.env.VUE_APP_SITHMES_PRD_URL}/sithMesPrdProjectPlanDetailPpd/shortDetailTreeList?prpId=${this.prpId}`
                }).then(response => {
                    console.log(response);
                    this.detailTreeList = response;
                }).finally(() => this.loading = false);
            }
        },
        prpSelected(item) {
            console.log(item);
            this.$store.commit('sithMesPrdPpdScheduledResultItemPsri/setEntityHolder', {
                psriIdPdsr: this.$store.state.routeStore.object.pdsrId,
                psriIdPpd: item.key,
                ppdChineseDescription: item.value.substring(item.value.lastIndexOf("-"))
            })
            this.$nextTick(() => this.$refs.emTable.gotoAddNewEntity());
        },
    }
};
</script>